import {Component, OnDestroy, OnInit} from '@angular/core';
import {ThemeConstantService} from '../../services/theme-constant.service';
import {LocalStorage, SessionStorage} from '@core/storage/storage';
import {Router} from '@angular/router';
import {Utils} from '@core/utils/utils';
import {ROUTES as AUTH_ROUTES} from '@modules/authentication/authentication-routing.module';
import {ROUTES as ADMIN_ROUTES} from '@modules/administration/administration-routing.module';
import {User} from '@modules/administration/users/interfaces/user.model';
import {LOCAL_STORAGE} from '@core/constant/storage.constant';
import {RoleTypes} from '@modules/administration/administration.const';
import {CurrentUserService} from '@shared/services/current-user.service';
import {BaseResponse} from '@core/models/base-response.model';
import {MESSAGE_CODE} from '@shared/constants/message-code.constant';
import {NotiHistoryService} from '@shared/services/noti-history.service';
import {OrderFilterService} from '@shared/services/order-filter.service';
import {format, subDays} from 'date-fns';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
})

export class HeaderComponent implements OnInit, OnDestroy {
  readonly RoleTypes = RoleTypes;
  readonly LAST_VIEWED_KEY = 'noti_last_viewed_ts';
  readonly POLL_INTERVAL_MS = 30000;

  searchVisible: boolean = false;
  quickViewVisible: boolean = false;
  isFolded: boolean;
  isExpand: boolean;

  user: User = LocalStorage.getItem(LOCAL_STORAGE.KEY.USER);
  notificationList: any[] = [];
  notiUnreadCount: number = 0;

  private pollTimer: any;

  constructor(private themeService: ThemeConstantService,
              public currentUserService: CurrentUserService,
              private router: Router,
              private notiHistoryService: NotiHistoryService,
              private orderFilterService: OrderFilterService) {
  }

  ngOnInit(): void {
    this.themeService.isMenuFoldedChanges.subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges.subscribe(isExpand => this.isExpand = isExpand);
    this.fetchNotifications();
    this.pollTimer = setInterval(() => this.fetchNotifications(), this.POLL_INTERVAL_MS);
  }

  ngOnDestroy(): void {
    if (this.pollTimer) {
      clearInterval(this.pollTimer);
    }
  }

  loadRecentNotifications() {
    const lastViewedTs = Number(localStorage.getItem(this.LAST_VIEWED_KEY) || 0);
    localStorage.setItem(this.LAST_VIEWED_KEY, String(Date.now()));
    this.notiUnreadCount = 0;
    this.fetchNotifications();
  }

  private fetchNotifications() {
    const today = new Date();
    this.notiHistoryService.getHistory({
      pageNumber: 1,
      pageSize: 10,
      fromDate: format(subDays(today, 30), 'yyyy-MM-dd'),
      toDate: format(today, 'yyyy-MM-dd'),
      isSent: 1
    }).subscribe((res: BaseResponse<any, any>) => {
      if (res?.messageCode === MESSAGE_CODE.SUCCESS) {
        this.notificationList = res.data.content || [];
        const lastViewedTs = Number(localStorage.getItem(this.LAST_VIEWED_KEY) || 0);
        this.notiUnreadCount = this.notificationList.filter(n => (n.createdDate || 0) > lastViewedTs).length;
      }
    });
  }

  toggleFold() {
    this.isFolded = !this.isFolded;
    this.themeService.toggleFold(this.isFolded);
  }

  toggleExpand() {
    this.isFolded = false;
    this.isExpand = !this.isExpand;
    this.themeService.toggleExpand(this.isExpand);
    this.themeService.toggleFold(this.isFolded);
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
  }



  signOut() {
    LocalStorage.clear();
    this.router.navigate([Utils.getRoute(AUTH_ROUTES.LOGOUT, AUTH_ROUTES.PREFIX)]);
  }

  redirectProfile() {
    this.router.navigate([Utils.getRoute('profile', ADMIN_ROUTES.PREFIX)]);
  }

  onNotiClick(item: any) {
    if (!item.orderId) return;
    this.orderFilterService.setOrderId(item.orderId);
    this.router.navigate([Utils.getRoute('orders', ADMIN_ROUTES.PREFIX)]);
  }

  openNewTab() {

  }

}
